import { ref } from 'vue'
import { defineStore } from 'pinia'

type ProfileState = {
  onboardingCompleted: boolean
}

export const useProfileStore = defineStore('profile', () => {
  const profile = ref<ProfileState | null>(null)
  const hasCheckedProfile = ref(false)
  /** Booking-only Clerk account: the provider app must stay closed for it. */
  const isGuestOnlyAccount = ref(false)

  function setProfile(nextProfile: ProfileState | null) {
    profile.value = nextProfile
    hasCheckedProfile.value = true
    isGuestOnlyAccount.value = false
  }

  function markProfileCheckedWithoutData() {
    hasCheckedProfile.value = true
  }

  function markGuestOnlyAccount() {
    profile.value = null
    hasCheckedProfile.value = true
    isGuestOnlyAccount.value = true
  }

  function markOnboardingCompleted() {
    if (!profile.value) {
      profile.value = { onboardingCompleted: true }
      hasCheckedProfile.value = true
      return
    }
    profile.value.onboardingCompleted = true
  }

  function resetProfileState() {
    profile.value = null
    hasCheckedProfile.value = false
    isGuestOnlyAccount.value = false
  }

  return {
    profile,
    hasCheckedProfile,
    isGuestOnlyAccount,
    setProfile,
    markProfileCheckedWithoutData,
    markGuestOnlyAccount,
    markOnboardingCompleted,
    resetProfileState,
  }
})
